import React from "react";

export const PrivateBrandingContext = React.createContext({});

export const PrivateBrandingProvider = PrivateBrandingContext.Provider;
